import React, {ReactNode} from 'react';

import {useStore} from 'effector-react';

import {permissions$, profile$, $mainRole} from 'models/auth';
import {UserPermission, UserRoles} from 'types';

interface Props {
    permissions?: UserPermission[];
    children: ReactNode;
    placeholder?: ReactNode;
    roleAccess?: UserRoles[];
}

export function PermissionAccess({children, permissions, placeholder, roleAccess}: Props) {
    const mainRole = useStore($mainRole);
    const currentPermissions = useStore(permissions$);
    const user = useStore(profile$);
    if (!user) {
        return <>{placeholder ?? null}</>;
    }

    const allowedByRole = mainRole && roleAccess?.includes(mainRole);

    if (
        !permissions ||
        permissions.some((elem) => currentPermissions?.includes(elem)) ||
        allowedByRole
    ) {
        return <>{children}</>;
    }

    return <>{placeholder ?? null}</>;
}
